import * as React from 'react';

import SkillPathwayAttainmentsDataContext from 'bundles/skills-common/shared/verified-skills/context/skill-pathway/SkillPathwayAttainmentsDataContext';
import useGetOccupationGroupAndCareerBand from 'bundles/skills-common/shared/verified-skills/data/skill-pathway/useGetOccupationGroupAndCareerBand';
import useGetSkillAttainmentByOccupationGroupAndCareerBand from 'bundles/skills-common/shared/verified-skills/data/skill-pathway/useGetSkillAttainmentByOccupationGroupAndCareerBand';

type Props = {
  children: React.ReactNode;
  courseId: string;
  isPracticeAssignment?: boolean;
};

const SkillPathwayAttainmentsDataProvider = ({ children, courseId, isPracticeAssignment }: Props) => {
  const {
    occupationGroup,
    careerBand,
    loading: loadingOccupationGroupAndCareerBand,
  } = useGetOccupationGroupAndCareerBand({ courseId });

  const { skillAttainments, loading, refetchSkillAttainments } = useGetSkillAttainmentByOccupationGroupAndCareerBand({
    occupationGroupId: occupationGroup?.id,
    careerBand,
    skip: isPracticeAssignment,
  });

  return (
    <SkillPathwayAttainmentsDataContext.Provider
      value={{
        skillAttainments,
        refetchSkillAttainments,
        loading: loadingOccupationGroupAndCareerBand || loading,
      }}
    >
      {children}
    </SkillPathwayAttainmentsDataContext.Provider>
  );
};

export default SkillPathwayAttainmentsDataProvider;
